"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Link = require("./Link");

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Link2.default;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wel-ui/component-link/lib/index.js
// module id = 372
// module chunks = 0